import React from 'react';
import { useParams } from 'react-router-dom';

import TaskForm from '@/forms/TaskForm';
import useAPI from '@/hooks/useAPI';
import WorkRepository from '@/repositories/WorkRepository';
import Container from '@/ui/components/Container';
import Spinner from '@/ui/components/Spinner';

const Task = () => {
  // Pull path params from the URL
  const { itemId } = useParams();
  const workRepo = WorkRepository();

  const { isPending: isLoadingTask, data: itemsResponse } = useAPI({
    queryKey: ['getItem', itemId],
    queryFn: async () => {
      return await workRepo.getItem(itemId as string);
    }
  });

  if (isLoadingTask) {
    return (
      <div className="flex items-center p-3">
        <Spinner label="Loading ..." />
      </div>
    );
  }

  return (
    <Container type="page">
      <TaskForm
        taskableId={itemsResponse?.data?.person_id as string}
        taskableType={itemsResponse?.data?.taskable_type as string}
        personId={itemsResponse?.data?.person_id as string}
        item={itemsResponse?.data}
      />
    </Container>
  );
};
export default React.memo(Task);
